// import NoDataImg from "../../Assets/Images/no-data-img.png"
import NoDataImg from "../../Assets/Images/Dashboard/no-data.png";

import "./NoDataPrompt.css"

export default function NoDataPrompt() {
    return(
        <div className="no-data-cont">
            <img src={NoDataImg} alt="no data found" />
            <span>No data found.</span>
        </div>
    )
}